module.exports = __webpack_public_path__ + "images/emoji/arrow_up_down.277ad90b68ccfb71e1a8.png";